import { Injectable } from '@angular/core';

export type InsightType = 'ActiveAlarms' | 'JBTStandardObservationId' | 'DurationInsight';
export type InsightScope = 'site' | 'gate' | 'asset' | 'organization';

export interface IAlarmHistoryRecord {
  AlarmEndDateUTC: Date;
  AlarmEndDateUTCMS: number;
  AlarmName: string;
  AlarmStartDateUTC: Date;
  AlarmStartDateUTCMS: number;
  AssetId: number;
  AssetName: string;
  DurationInSeconds: number;
  GateId: number;
  GateName: string;
  SiteName: string;
  SiteUTCTimeOffset: number;
  StandardObservationId: number;
  TagId: number;
  Category?: string;
  EffectiveAlarmCategoryName?: string;
  EffectiveAlarmCategory?: string;
}

export interface IStandardHistoricalRecord {
  AssetId: number;
  AssetName: string;
  SiteId: number;
  SiteName: string;
  GateId: number;
  GateName: string;
  Name: string;
  StandardObservationId: number;
  TagId: number;
  SiteUTCTimeOffset: number;
  DateUTC: Date;
  Value: number | string;
}

export interface IDurationHistoricalRecord {
  AssetId: number;
  AssetName: string;
  SiteId: number;
  SiteName: string;
  GateId: number;
  GateName: string;
  Name: string;
  StandardObservationId: number;
  TagId: number;
  SiteUTCTimeOffset: number;
  StartDateUTC: Date;
  EndtDateUTC: Date;
  DurationInSeconds: number;
}

export interface HistoricalCacheEntry {
  timestamp: number;
  kind: InsightType;
  records: IAlarmHistoryRecord[] | IStandardHistoricalRecord[] | IDurationHistoricalRecord[];
  groupedData: any;
  topGates: { key: string; value: number; meta: any }[];
  topAssets: { key: string; value: number; meta: any }[];
  topTags: { key: string; value: number; meta: any }[];
}

@Injectable({ providedIn: 'root' })
export class HistoricalInsightsService {
  private cache = new Map<string, HistoricalCacheEntry>();
  private readonly TTL = 10 * 60 * 1000; // 10 minutes

  private getKey(insightType: InsightType, scope: InsightScope, id?: number): string {
    const idPart = scope === 'organization' ? 'org' : id?.toString() ?? 'unknown';
    return `${insightType}_${scope}_${idPart}`;
  }

  set(
    insightType: InsightType,
    scope: InsightScope,
    id: number | undefined,
    entry: Omit<HistoricalCacheEntry, 'timestamp' | 'kind'>
  ) {
    const key = this.getKey(insightType, scope, id);
    this.cache.set(key, {
      ...entry,
      kind: insightType,
      timestamp: Date.now()
    });
  }

  get(insightType: InsightType, scope: InsightScope, id: number | undefined): HistoricalCacheEntry | null {
    const key = this.getKey(insightType, scope, id);
    const entry = this.cache.get(key);
    if (!entry || Date.now() - entry.timestamp > this.TTL) {
      this.cache.delete(key);
      return null;
    }
    return entry;
  }

  
}
